/* eslint-disable check-file/filename-blocklist */
import { defineMessages } from 'react-intl';

export const i18n: {
	placeholderBracketHint: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	blogpostPermissionsNotice: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	editorEmptyDocumentPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	editorEmptyDocumentPlaceholderAI: {
		id: string;
		// eslint-disable-next-line no-restricted-syntax
		defaultMessage: string;
		description: string;
	};
	editorEmptyDocumentSpaceShortcutPlaceholder: {
		id: string;
		// eslint-disable-next-line no-restricted-syntax
		defaultMessage: string;
		description: string;
	};
	editorEmptyDocumentMarkdownPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commentLinkNotFoundFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commentLinkNotFoundFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commentRemovedByRovoTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commentRemovedByRovoDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commentRemovedByRovoViewCommentCTA: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	placeholderBracketHint: {
		id: 'full-page-editor.place.holder.bracket.hint',
		defaultMessage: 'Any element can be quickly inserted by typing /',
		description:
			'The placeholder text that appears in editor that already have content when user enter a new line and type {',
	},
	blogpostPermissionsNotice: {
		id: 'full-page-editor.permissions.blogpost-access',
		defaultMessage: 'Default access to this blog is now in effect.',
		description: 'Notice when selecting the blogpost blueprint to update preset access settings',
	},
	editorEmptyDocumentPlaceholder: {
		id: 'full-page-editor.content.placeholder.empty.doc',
		defaultMessage: 'Type / to insert elements',
		description: 'The placeholder shown in empty document to help discover slash command',
	},
	editorEmptyDocumentPlaceholderAI: {
		id: 'full-page-editor.content.placeholder.empty.doc.ai',
		// eslint-disable-next-line no-restricted-syntax
		defaultMessage: "Use {key}+' to ask AI, or type / to insert elements",
		description: 'The placeholder shown in empty document to help discover ai and slash command',
	},
	editorEmptyDocumentSpaceShortcutPlaceholder: {
		id: 'full-page-editor.content.placeholder.space-shortcut',
		// eslint-disable-next-line no-restricted-syntax
		defaultMessage: 'Press space to Ask Rovo or / to insert elements',
		description:
			'The placeholder shown in empty document to help discover space shortcut to trigger Rovo, and slash shortcut to insert elements',
	},
	editorEmptyDocumentMarkdownPlaceholder: {
		id: 'full-page-editor.content.placeholder.markdown-mode',
		defaultMessage: 'Type or paste markdown',
		description:
			'The placeholder shown in an empty Live Doc when the editor is in Markdown Mode, prompting the user to type or paste markdown.',
	},
	commentLinkNotFoundFlagTitle: {
		id: 'full-page-editor.comment-link-not-found.flag.title',
		defaultMessage: 'This comment is not available',
		description:
			'The title for a warning message informing the user they clicked on a link to a comment that no longer exists because it is probably deleted.',
	},
	commentLinkNotFoundFlagDescription: {
		id: 'full-page-editor.comment-link-not-found.flag.description',
		defaultMessage: 'It may be deleted.',
		description:
			'A warning message informing the user they clicked on a link to a comment that no longer exists because it is probably deleted.',
	},
	commentRemovedByRovoTitle: {
		id: 'full-page-editor.rovo.removed.flag.title',
		defaultMessage: 'Comments deleted',
		description:
			'Text in an info flag title which is displayed after Rovo replaces content which had a comment and now the comment is lost',
	},
	commentRemovedByRovoDescription: {
		id: 'full-page-editor.rovo.removed.flag.description',
		defaultMessage: 'One or more comments were deleted in your latest edit with Rovo.',
		description:
			'Text in an info flag body which is displayed after Rovo replaces content which had a comment but the comment was removed',
	},
	commentRemovedByRovoViewCommentCTA: {
		id: 'full-page-editor.rovo.removed.flag.cta.view-comment',
		defaultMessage: 'Go to comment',
		description:
			'CTA button text displayed in Flag for users to open the comment in the comments panel that was just removed.',
	},
});
